import { useCallback, useEffect } from 'react';
import { useAppContext } from '../context/AppContext';

export function useScrollToTop() {
  const appContext = useAppContext();

  return useCallback(() => {
    if (appContext === 'public') {
      window.scrollTo(0, 0);
      return;
    }

    // scroll to top of page in-app is a little trickier b/c of the global nav
    const pageDiv = document.querySelector('.quartz-grid-app-container');
    pageDiv?.scrollTo(0, 0);
  }, [appContext]);
}

export function ScrollToTopOnMount() {
  const scrollToTop = useScrollToTop();

  useEffect(() => {
    requestAnimationFrame(() => {
      scrollToTop();
    });
  }, [scrollToTop]);

  return null;
}
